// extracted by mini-css-extract-plugin
module.exports = {"payment-failed":"PaymentFailed_payment-failed__2V-pE","icon":"PaymentFailed_icon__1GoP2","title":"PaymentFailed_title__2lvuz","description":"PaymentFailed_description__C9WJe"};